import userCourseHistoryApi from 'Api/axios/user-course-histories-api';
import { useEffect, useState } from 'react';
import type { HistoryCoursesFilterI, HistoryCourseI, JsonApiMetaI } from 'types';

interface Props {
  init?: boolean;
}

const useHistoryCoursesApi = ({ init = false }: Props) => {
  const [data, setData] = useState<HistoryCourseI[]>([]);
  const [meta, setMeta] = useState<JsonApiMetaI | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchHistoryCourses = async (filters: HistoryCoursesFilterI = {}) => {
    setLoading(true);
    setError(null);

    const response = await userCourseHistoryApi.getCoursesCollection(filters);

    setLoading(false);

    if (response.data) {
      setData(response.data ?? []);
      setMeta(response.meta ?? null);
    } else {
      setError(response.error ?? 'No hay datos disponibles');
    }
  };

  useEffect(() => {
    if (init) {
      fetchHistoryCourses();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [init]);

  return { data, meta, loading, error, fetchHistoryCourses };
};

export default useHistoryCoursesApi;
